import React from 'react';
import { useState, useEffect } from "react";

import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

import Logo from '../assets/img/Waleed-Logo.gif';
import NavIcon1 from '../assets/img/nav-icon1.svg';
import NavIcon2 from '../assets/img/nav-icon2.svg';
import NavIcon3 from '../assets/img/nav-icon3.svg';

const myNavbar = () => {
    const [activeLink, setActiveLink] = useState('home');
    const [scrolled, setScrolled] = useState(false);

    const onUpdateActiveLink = (value) => {
        setActiveLink(value);
    }

    useEffect(() => {
        //Scrolled Function
        const onScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        }

        window.addEventListener("scroll", onScroll);
    }, [])
    return (
        <Navbar expand="lg" className={
            scrolled ? "scrolled"
                : ""
        }>
            <Container>
                <Navbar.Brand href="#home">
                    <img src={Logo} alt='logo or brand name' />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav">
                    <span className='navbar-toggler-icon'></span>
                </Navbar.Toggle>
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link href="#home" className={
                            activeLink === 'home' ?
                                'active navbar-link'
                                : 'navbar-link'
                        }
                            onClick={() => onUpdateActiveLink('home')}>Home</Nav.Link>
                        <Nav.Link href="#skills" className={
                            activeLink === 'skills' ?
                                'active navbar-link'
                                : 'navbar-link'
                        }
                            onClick={() => onUpdateActiveLink('skills')}>Skills</Nav.Link>
                        <Nav.Link href="#project" className={
                            activeLink === 'project' ?
                                'active navbar-link'
                                : 'navbar-link'
                        }
                            onClick={() => onUpdateActiveLink('project')}>Project</Nav.Link>
                    </Nav>
                    <span className='navbar-text'>
                        <div className='social-icon'>
                            <a href="https://www.linkedin.com/in/myselfswk/" target={'_blank'}><img src={NavIcon1} alt="LinkedIn" /></a>
                            <a href="https://www.facebook.com/myselfswk" target={'_blank'}><img src={NavIcon2} alt="Facebook" /></a>
                            <a href="https://www.instagram.com/myselfswk/" target={'_blank'}><img src={NavIcon3} alt="Instagram" /></a>
                        </div>
                        <button className='vvd' onClick={() => console.log('Connect')}>
                            <span>Let's Connect</span>
                        </button>
                    </span>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    )
}

export default myNavbar;